import { notify } from 'utils/reduxUtils';

export const types = {
  ACCOUNT_DETAILS_INIT: 'contacts/accountDetails/ACCOUNT_DETAILS_INIT',
  ADD_CONTACT_ERROR: 'contacts/accountDetails/ADD_CONTACT_ERROR',
  ADD_CONTACT_REQUEST: 'contacts/accountDetails/ADD_CONTACT_REQUEST',
  ADD_CONTACT_SUCCESS: 'contacts/accountDetails/ADD_CONTACT_SUCCESS',
  DELETE_ACCOUNT_ERROR: 'contacts/accountDetails/DELETE_ACCOUNT_ERROR',
  DELETE_ACCOUNT_REQUEST: 'contacts/accountDetails/DELETE_ACCOUNT_REQUEST',
  DELETE_ACCOUNT_SUCCESS: 'contacts/accountDetails/DELETE_ACCOUNT_SUCCESS',
  DELETE_BILLING_ADDRESS_ERROR:
    'contacts/accountDetails/DELETE_BILLING_ADDRESS_ERROR',
  DELETE_BILLING_ADDRESS_REQUEST:
    'contacts/accountDetails/DELETE_BILLING_ADDRESS_REQUEST',
  DELETE_BILLING_ADDRESS_SUCCESS:
    'contacts/accountDetails/DELETE_BILLING_ADDRESS_SUCCESS',
  DELETE_FACILITY_ERROR: 'contacts/accountDetails/DELETE_FACILITY_ERROR',
  DELETE_FACILITY_REQUEST: 'contacts/accountDetails/DELETE_FACILITY_REQUEST',
  DELETE_FACILITY_SUCCESS: 'contacts/accountDetails/DELETE_FACILITY_SUCCESS',
  FETCH_ACCOUNT_ERROR: 'contacts/accountDetails/FETCH_ACCOUNT_ERROR',
  FETCH_ACCOUNT_REQUEST: 'contacts/accountDetails/FETCH_ACCOUNT_REQUEST',
  FETCH_ACCOUNT_SUCCESS: 'contacts/accountDetails/FETCH_ACCOUNT_SUCCESS',
  FETCH_BILLING_ADDRESS_ERROR:
    'contacts/accountDetails/FETCH_BILLING_ADDRESS_ERROR',
  FETCH_BILLING_ADDRESS_REQUEST:
    'contacts/accountDetails/FETCH_BILLING_ADDRESS_REQUEST',
  FETCH_BILLING_ADDRESS_SUCCESS:
    'contacts/accountDetails/FETCH_BILLING_ADDRESS_SUCCESS',
  FETCH_CONTACT_ERROR: 'contacts/accountDetails/FETCH_CONTACT_ERROR',
  FETCH_CONTACT_REQUEST: 'contacts/accountDetails/FETCH_CONTACT_REQUEST',
  FETCH_CONTACT_SUCCESS: 'contacts/accountDetails/FETCH_CONTACT_SUCCESS',
  FETCH_FACILITY_ERROR: 'contacts/accountDetails/FETCH_FACILITY_ERROR',
  FETCH_FACILITY_REQUEST: 'contacts/accountDetails/FETCH_FACILITY_REQUEST',
  FETCH_FACILITY_SUCCESS: 'contacts/accountDetails/FETCH_FACILITY_SUCCESS',
  UPDATE_METADATA_ERROR: 'contacts/accountDetails/UPDATE_METADATA_ERROR',
  UPDATE_METADATA_REQUEST: 'contacts/accountDetails/UPDATE_METADATA_REQUEST',
  UPDATE_METADATA_SUCCESS: 'contacts/accountDetails/UPDATE_METADATA_SUCCESS',
  REMOVE_CONTACT_ERROR: 'contacts/accountDetails/REMOVE_CONTACT_ERROR',
  REMOVE_CONTACT_REQUEST: 'contacts/accountDetails/REMOVE_CONTACT_REQUEST',
  REMOVE_CONTACT_SUCCESS: 'contacts/accountDetails/REMOVE_CONTACT_SUCCESS',
};

export const accountDetails = {
  init: ({ accountId }) => ({
    type: types.ACCOUNT_DETAILS_INIT,
    payload: { accountId },
  }),
};

export const addContact = {
  error: notify(
    (error) => ({
      type: types.ADD_CONTACT_ERROR,
      payload: error,
    }),
    'Failed to add contact',
  ),
  request: ({ contactId }) => ({
    type: types.ADD_CONTACT_REQUEST,
    payload: { contactId },
  }),
  success: ({ contactId }) => ({
    type: types.ADD_CONTACT_SUCCESS,
    payload: { contactId },
  }),
};

export const deleteAccount = {
  error: notify(
    (error) => ({
      type: types.DELETE_ACCOUNT_ERROR,
      payload: error,
    }),
    'Failed to delete account',
  ),
  request: () => ({
    type: types.DELETE_ACCOUNT_REQUEST,
  }),
  success: notify(
    () => ({
      type: types.DELETE_ACCOUNT_SUCCESS,
    }),
    'Successfully deleted account',
  ),
};

export const deleteBillingAddress = {
  error: notify(
    (error) => ({
      type: types.DELETE_BILLING_ADDRESS_ERROR,
      payload: error,
    }),
    'Failed to remove billing address',
  ),
  request: ({ billingAddressId }) => ({
    type: types.DELETE_BILLING_ADDRESS_REQUEST,
    payload: { billingAddressId },
  }),
  success: ({ billingAddressId }) => ({
    type: types.DELETE_BILLING_ADDRESS_SUCCESS,
    payload: { billingAddressId },
  }),
};

export const deleteFacility = {
  error: notify(
    (error) => ({
      type: types.DELETE_FACILITY_ERROR,
      payload: error,
    }),
    'Failed to remove facility',
  ),
  request: ({ facilityId }) => ({
    type: types.DELETE_FACILITY_REQUEST,
    payload: { facilityId },
  }),
  success: ({ facilityId }) => ({
    type: types.DELETE_FACILITY_SUCCESS,
    payload: { facilityId },
  }),
};

export const fetchBillingAddress = {
  error: notify(
    (error) => ({
      type: types.FETCH_BILLING_ADDRESS_ERROR,
      payload: error,
    }),
    'Failed to get billing address',
  ),
  request: ({ billingAddressId }) => ({
    type: types.FETCH_BILLING_ADDRESS_REQUEST,
    payload: { billingAddressId },
  }),
  success: ({ billingAddressId }) => ({
    type: types.FETCH_BILLING_ADDRESS_SUCCESS,
    payload: { billingAddressId },
  }),
};

export const fetchContact = {
  error: notify(
    (error) => ({
      type: types.FETCH_CONTACT_ERROR,
      payload: error,
    }),
    'Failed to get contact',
  ),
  request: ({ contactId }) => ({
    type: types.FETCH_CONTACT_REQUEST,
    payload: { contactId },
  }),
  success: ({ contactId }) => ({
    type: types.FETCH_CONTACT_SUCCESS,
    payload: { contactId },
  }),
};

export const fetchFacility = {
  error: notify(
    (error) => ({
      type: types.FETCH_FACILITY_ERROR,
      payload: error,
    }),
    'Failed to get facility',
  ),
  request: ({ facilityId }) => ({
    type: types.FETCH_FACILITY_REQUEST,
    payload: { facilityId },
  }),
  success: ({ facilityId }) => ({
    type: types.FETCH_FACILITY_SUCCESS,
    payload: { facilityId },
  }),
};

export const fetchAccount = {
  error: notify(
    (error) => ({
      type: types.FETCH_ACCOUNT_ERROR,
      payload: error,
    }),
    'Failed to load account',
  ),
  request: () => ({
    type: types.FETCH_ACCOUNT_REQUEST,
  }),
  success: () => ({
    type: types.FETCH_ACCOUNT_SUCCESS,
  }),
};

export const removeContact = {
  error: notify(
    (error) => ({
      type: types.REMOVE_CONTACT_ERROR,
      payload: error,
    }),
    'Failed to remove contact',
  ),
  request: ({ contactId }) => ({
    type: types.REMOVE_CONTACT_REQUEST,
    payload: { contactId },
  }),
  success: ({ contactId }) => ({
    type: types.REMOVE_CONTACT_SUCCESS,
    payload: { contactId },
  }),
};

export const updateMetadata = {
  error: notify(
    (error) => ({
      type: types.UPDATE_METADATA_ERROR,
      payload: error,
    }),
    'Failed to update metadata',
  ),
  request: ({ metadata }) => ({
    type: types.UPDATE_METADATA_REQUEST,
    payload: { metadata },
  }),
  success: notify(
    () => ({
      type: types.UPDATE_METADATA_SUCCESS,
    }),
    'Metadata updated.',
  ),
};
